<script lang="ts">
	import { afterUpdate } from 'svelte';
	import ArrowLeft from 'assets/svg/arrowLeft.svg?component';
	import { pagination } from 'utils/pagination';
	import activeLocale from 'stores/activeLocale';

	export let linkTo: string;
	export let totalCount = 10;
	export let currentPage = 1;
	export let pageSize = 1;
	export let siblingCount = 1;
	export let dark: boolean;
	export let withLocale = false;

	let paginationRange = pagination(totalCount, pageSize, siblingCount, currentPage);

	afterUpdate(() => {
		paginationRange = pagination(totalCount, pageSize, siblingCount, currentPage);
	});

	$: lastPage = paginationRange.length > 0 ? paginationRange[paginationRange.length - 1] : 1;
	$: normalizedLocale = $activeLocale.locale === 'en' ? '/' : `/${$activeLocale.locale}`;
</script>

<ul class="pagination no-select" class:dark>
	<li>
		<a
			href={`${linkTo}` + `${currentPage - 1}` + `${withLocale ? normalizedLocale : ''}`}
			class="link prev"
			class:inactive={currentPage === 1}
		>
			<ArrowLeft
				width={7}
				height={16}
				class={`arrow-icon center ${currentPage === 1 ? 'inactive' : 'active'}`}
			/>
		</a>
	</li>
	{#each paginationRange as pageNumber}
		{#if pageNumber === '...'}
			<li class="dots">{pageNumber}</li>
		{:else}
			<li>
				<a
					href={`${linkTo}` + `${pageNumber}` + `${withLocale ? normalizedLocale : ''}`}
					class="link middle"
					class:selected={pageNumber === currentPage}>{pageNumber}</a
				>
			</li>
		{/if}
	{/each}
	<li>
		<a
			href={`${linkTo}` + `${currentPage + 1}` + `${withLocale ? normalizedLocale : ''}`}
			class="link next"
			class:inactive={currentPage === lastPage}
		>
			<ArrowLeft
				width={7}
				height={16}
				class={`arrow-icon rotate center ${currentPage === lastPage ? 'inactive' : 'active'}`}
			/>
		</a>
	</li>
</ul>

<style lang="scss">
	@import 'paginationSeo';
</style>
